const WYSIWYGTable = require('./modules/wysiwyg-table.js');
new WYSIWYGTable();

const PaginationMobileTrim = require('./modules/pagination-mobile-trim.js');
new PaginationMobileTrim();